import { render, staticRenderFns } from "./QuickAdd.vue?vue&type=template&id=488b4f22&"
import script from "./QuickAdd.vue?vue&type=script&lang=ts&"
export * from "./QuickAdd.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAdd.vue?vue&type=style&index=0&id=488b4f22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports